const Projects = () => import('~pages/Projects/Index.vue')
const ProjectDialog = () => import('~pages/Projects/ProjectDialog.vue')

export default [
  {
    name: 'projects',
    path: 'projects',
    component: Projects,
    children: [
      {
        name: 'project-new',
        path: 'project/new',
        components: {
          modal: ProjectDialog
        },
        meta: {
          showModal: true
        }
      },
      {
        name: 'project-edit',
        path: 'project/:projectId/edit',
        components: {
          modal: ProjectDialog
        },
        meta: {
          showModal: true
        }
      }
    ]
  }
]
